module.exports = __webpack_public_path__ + "static/media/Taggis_portfolio_laptop.d9081670.png";